import classNames from "classnames";
import { useState } from "react";
import AscButton from "../AscButton/AscButton";
import { AdminChevronDownIcon } from "../AscIcons";
import AscSelectInput from "../AscInputFields/AscSelectInput/AscSelectInput";
import AscModal from "../AscModal/AscModal";
import AscHeading from "../AscTypography/AscHeading/AscHeading";
import styles from "./AscBatchChangeStatus.module.scss";

export interface AscBatchChangeStatusProps {
  className?: string;
}

export default function AscBatchChangeStatus({
  className,
}: AscBatchChangeStatusProps) {
  const [visible, setVisible] = useState<boolean>(true);

  return (
    <AscModal
      visible={true}
      setVisible={setVisible}
      withBackground={false}
      modalClassName={styles.modal}
    >
      <div
        data-testid="asc-batch-change-status"
        className={classNames(styles.container, className)}
      >
        <AscHeading level={6} className={styles.title}>
          Change Status
        </AscHeading>

        <AscSelectInput
          className={styles.input}
          placeholder="Inactive"
          size="medium"
          arrowIcon={<AdminChevronDownIcon />}
        />
        <AscButton fullWidth={true} className={styles.button}>
          Save
        </AscButton>
      </div>
    </AscModal>
  );
}
